import * as React from "react"

export const PictoBlocks = (props: any) => (
  <svg width="1.7em" height="1.7em" viewBox="0 0 200 200" {...props}>
    <g fill={props.color}>
      <path d="M191.894 192.894h-27.886v-24.788h3.098v-3.098h24.788zM138.205 192.894h-25.803v-24.788h25.803v24.788zm-51.606 0H60.795v-24.788h25.803v24.788zM34.992 192.894H7.106v-27.886h24.788v3.098h3.098zM31.894 139.205H7.106v-25.803h24.788v25.803zm0-51.606H7.106V61.795h24.788v25.804zM31.894 35.992H7.106V8.106h27.886v24.788h-3.098zM138.205 32.894h-25.803V8.106h25.803v24.788zm-51.606 0H60.795V8.106h25.803v24.788zM191.894 35.992h-24.788v-3.098h-3.098V8.106h27.886zM191.894 139.205h-24.788v-25.803h24.788v25.803zm0-51.606h-24.788V61.795h24.788v25.804z" />
    </g>
  </svg>
)
